import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Button, Modal } from "react-bootstrap";
import {
    loginClear,
    loginBroker,
    loginBrokerClear,
    forgotPwdBroker,
    forgotPwdBrokerResponseClear,
    logoutClear,
    emailVerify,
    emailVerifyClear,
} from "../redux/auth/actions";
import {
    applyTheme,
    clickStreamUser,
    emailValidation,
    LOGIN_CHANNEL,
    logoutClearSession,
    SessionKeys,
    UserIsLoggedIn,
} from "../utils/AppUtils";
import { userDetailBroker } from "../redux/user/actions";
import axios from "axios";
import CONFIG from "../utils/config";
import { objectToFormData } from "../api/data";
import { LinearProgress } from "@mui/material";
import Spinner from "react-bootstrap/Spinner";
import ConfirmModal from "../components/modal/ConfirmModal";
import { myCart } from "../redux/Cart/actions";
import {
    getBannerCardSummary,
    setUserPremium,
    setUserRole,
} from "../redux/user/actions";
import { useTranslation } from "react-i18next";
import i18n from "../i18n";
import $ from "jquery";
import {
    getCoursesCategoriesFromBroker,
    getProductCategories,
} from "../redux/courses/actions";
import _ from "lodash";
import { Formik, useFormik } from "formik";
import * as Yup from "yup";
import { GoogleLogin, googleLogout, useGoogleLogin } from "@react-oauth/google";
import SocialLoginComp from "../components/login/SocialLoginComp";
import InputPasswordComp from "../components/login/InputPasswordComp";
import { useAuth } from "../utils/auth";
import moment from "moment";
import { getLiveCalendarSessionList } from "../redux/events/actions";
import Loader from "../components/Loader/Loader";
import { isAndroid, isIOS } from "react-device-detect";
import ForgotPasswordComp from "../components/forgotPassComponents/ForgotPasswordComp";
import SignUpComp from "../components/signup/SignUpComp";
import SignUPSuccess from "../components/signup/SignUpSuccess";
import SignUpOtp from "../components/signup/SignUpOtp";
import EmailVerifiedSuccess from "../components/signup/EmailVerifiedSuccess";

const SignUpPage = () => {
    const { t } = useTranslation();

    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const authProvider = useAuth()


    const search = window.location.search;
    const params = new URLSearchParams(search);
    const page = params.get('p');

    const [isLoading, setIsLoading] = useState(false);


    return (
        <>
            <Loader start={isLoading} />
            <div className="login-ary">
                <section className="login-sec ">
                    <div className="login-container ">
                        {/* <div className="bannerlog-image d-block d-md-none image-login">
                            <img className="img-fluid" src="images/login_img.jpg" />
                        </div> */}
                        {/* <div className="header-border"></div> */}
                        <div className="container-fluid">
                            <div className="row bglogin">
                                <div className="col-xl-7 col-lg-6 col-sm-12 col-12 image-login">
                                    <img
                                        className="img-fluid"
                                        src="images/sign-up.jpeg"
                                        alt="home-scene-login"
                                    />
                                </div>
                                {page === "1" && <SignUpComp />}
                                {page === "2" && <SignUPSuccess />}
                                {page === "3" && <SignUpOtp />}
                                {page === "4" && <EmailVerifiedSuccess />}
                            </div>
                        </div>
                    </div>
                </section>

            </div>

        </>
    );
};

export default SignUpPage;
